module.exports = __webpack_public_path__ + "static/media/foodheader.3001d8eb.png";